export default __webpack_public_path__ + "static/impact-photo-natalie-0925ed47bc004cda326bb247a20c4886.jpg";